import { all, fork } from 'redux-saga/effects';

import { takeStudentDataUpdateRequest } from './studentDataUpdateSaga';
import { takeStudentDataRequest, takeStudentDataSingleRequest } from './studentDataSaga';

const studentSagaRequest = function* () {
    yield all([fork(takeStudentDataUpdateRequest), fork(takeStudentDataRequest), fork(takeStudentDataSingleRequest)]);
};

export { studentSagaRequest };
